import React, { Component } from 'react';
import axios from 'axios';
import { Typography, withStyles, CircularProgress } from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import { Auth } from 'aws-amplify';
import { Redirect } from 'react-router-dom';
import ContentHeader from '../components/ContentHeader';

const styles = theme => ({
    root: {
        border: '0',
        maxWidth: '800px',
        margin: '40px auto',
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            margin: '20px 15px'
        }
    },
    innerRoot: {
        textAlign: 'center',
        border: '0',
        maxWidth: '800px',
        margin: '40px auto',
        position: 'relative',
        background: '#fff',
        boxShadow: '0px 2px 5px 0px rgba(0,0,0,0.21)',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            margin: '20px 15px'
        }
    },
    error: {
        margin: '20px 0 0 5px',
        color: red[500],
        minHeight: '20px'
    },
    spinner: {
        marginTop: '60px'
    },
    button: {
        height: '40px',
        marginTop: '10px',
        marginBottom: '10px'
    },
    inner: {
        padding: '20px 10px'
    },
    paragraph: {
        fontSize: '16px',
        marginBottom: '10px',
        fontWeight: '100'
    }
});

class MandateConfirmed extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mandateSessionConfirmed: false,
            error: '',
            isLoading: true
        };
    }

    async componentDidMount() {
        const {
            match: {
                params: {
                    clientSlug,
                    serviceId,
                    ticketId,
                    sessionId,
                    renewalId
                }
            }
        } = this.props;

        const mandateSessionConfirmed = await this.postConfirmMandateSession(
            clientSlug,
            serviceId,
            ticketId,
            sessionId,
            renewalId
        );

        this.setState({
            mandateSessionConfirmed,
            isLoading: false
        });
    }

    buyTicketUrl = (clientSlug, serviceId, ticketId, year, renewalId) => {
        if (renewalId) {
            return `/renew/${renewalId}`;
        }

        return `/create-ticket/${year}/${clientSlug}/${serviceId}/${ticketId}`;
    };

    async postConfirmMandateSession(
        clientSlug,
        serviceId,
        ticketId,
        sessionId,
        renewalId
    ) {
        try {
            const currentSession = await Auth.currentSession();

            const headers = {
                Authorization: currentSession.getIdToken().getJwtToken()
            };

            await axios.post(
                `${process.env.REACT_APP_PAYMENT_API_ENDPOINT}/customer-mandate-session/confirm/${sessionId}`,
                {
                    service_id: serviceId,
                    ticket_id: ticketId,
                    client_slug: clientSlug,
                    renewal_id: renewalId
                },
                {
                    headers
                }
            );

            return true;
        } catch (e) {
            this.setState({
                error:
                    'There was a problem whilst trying to confirm your direct debit mandate. Please try again later or contact support if this issue continues.'
            });
            return false;
        }
    }

    render() {
        const {
            classes,
            match: {
                params: { clientSlug, year, serviceId, ticketId, renewalId }
            }
        } = this.props;
        const { mandateSessionConfirmed, error, isLoading } = this.state;
        const ticketUrl = this.buyTicketUrl(
            clientSlug,
            serviceId,
            ticketId,
            year,
            renewalId
        );

        if (!isLoading && mandateSessionConfirmed === true) {
            return <Redirect to={ticketUrl} />;
        }

        return (
            <div className={classes.root}>
                <div className={classes.innerRoot}>
                    <ContentHeader
                        text="Setup direct debit mandate"
                        id="create-mandate-heading"
                    />
                    <div className={classes.inner}>
                        {isLoading && (
                            <CircularProgress
                                id="loading-spinner"
                                className={classes.spinner}
                            />
                        )}

                        {!isLoading && error !== '' && (
                            <Typography
                                className={classes.paragraph}
                                variant="body2"
                                style={{ color: 'red' }}
                            >
                                {error}
                            </Typography>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(MandateConfirmed);
